export const allocation = [
    { category: "Domestic", value: 48.5 },
    { category: "International", value: 14.4 },
    { category: "Bonds", value: 17.0 },
    { category: "Cash", value: 20.1 },
  ];